import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './data/App';
import Hero from './data/Hero.jsx';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Hero />
  </React.StrictMode>
);
